import { Box, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { AddButton } from "share-components/mui-wrap/button/action-button";

type DialogComplexFormArrayProps = {
  children: ReactNode;
  addNewRow?: () => void;
  label?: string;
};
export const DialogComplexFormArrayContainer = (
  props: DialogComplexFormArrayProps
) => {
  return (
    <Stack direction={"column"} flex={1} sx={{ overflow: "hidden" }}>
      <Stack
        direction={"row"}
        spacing={1}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography variant="subtitle2">{props.label || ""}</Typography>
        {props.addNewRow && (
          <AddButton
            onClick={() => {
              props.addNewRow?.();
            }}
          ></AddButton>
        )}
      </Stack>

      <Box sx={{ overflow: "auto" }}>{props.children}</Box>
    </Stack>
  );
};
